import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './IssuePage.css'

@CSSModules(Styles, {allowMultiple:true})
export default class IssueGenderEquality extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'The issue: Gender equality',
      description: 'Collecting data and scoring companies on gender equality is the first step towards sustainable change.',
      url: config.domain + config.routes.issueGenderEquality
    }
  }

  render() {
    return (
      <div styleName='page issue-gef'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <section styleName='section'>
            <h1 styleName='issue-top-label'>
              The issue: <span>Gender equality</span>
            </h1>
            <h2 styleName='issue-top-headline'>
              Companies with gender equality are positioned for success
            </h2>
            <h3 styleName='issue-top-copy'>
              Collecting data and scoring companies on gender equality is the first step towards sustainable change.
            </h3>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={4}>
                <div styleName='issue-second-headline'>
                  <span style={{whiteSpace: 'nowrap'}}>&mdash;&mdash;&mdash;&mdash;</span>
                  <br/>
                  <h2>Retirement plans are investing companies that score poorly on gender equality</h2>
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div styleName='issue-second-copy'>
                  <p>Female leadership is crucial, given there are only 6% female CEOs in the S&P 500. But gender diversity is not only necessary at the top; it’s equally important across all levels of a company, from the boardroom to executive, management and workforce levels.</p>
                  <p>Asset managers like Vanguard are investing in companies that score poorly on gender equality – and they’re using workers’ retirement plan savings to do so. Through Vanguard, the retirement plans of companies like Amazon and Comcast are investing millions in publicly-traded companies with poor gender balance and poor adoption of policies promoting gender equality.</p>
                </div>
              </Col>
            </Row>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={6}>
                <div styleName='img-issue'/>
              </Col>
              <Col xs={12} md={6}>
                <div>
                  <h2 styleName='issue-focus-label'>
                    FOCUS: SUSTAINABILITY RISK
                  </h2>
                  <h3 styleName='issue-focus-headline'>
                    Companies that score poorly on gender equality
                  </h3>
                  <div styleName='issue-focus-copy'>
                    <p>
                      Our gender equality fund ratings are powered by
                      the <Link
                        to={'https://equileap.com/equileap-reports/'}
                        title='Equileap reports'
                        xstrong
                      >Equileap Gender Equality Scorecard</Link>, inspired by the UN’s Women Empowerment Principles. The Equileap Gender Equality Scorecard scores companies based on 19 criteria, including gender balance across the workforce, the gender pay gap, paid parental leave, and anti-sexual harassment policies.
                    </p>
                    <p>
                      <Link
                        to={config.routes.companies + '#genderequality'}
                        title='Companies: Gender equality'
                        xstrong
                      >
                        Learn more<LinkIcon />
                      </Link>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </ContainerDivs>
        <div styleName='section-solutions-faq-background'>
          <ContainerDivs>
            <section styleName='section section-solutions-faq'>
              <Row>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-solutions-label'>
                      The Solutions
                    </h2>
                    <h3 styleName='issue-solutions-headline'>
                      Offer gender lens retirement plan options
                    </h3>
                    <div styleName='issue-solutions-copy'>
                      <p>
                        Company retirement plans should offer fund options that are sustainably invested and invest with a gender lens.
                      </p>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.solutionOfferSustainability}
                        title='Solution: Offer sustainability'
                        xstrong
                      >
                        Explore solutions<LinkIcon/>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-faqs-label'>
                      FAQs
                    </h2>
                    <div styleName='issue-faqs-headline'>
                      Answers to common questions about how retirement plans and asset managers are financing gender inequality.
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-'}
                        title='Do I have to sacrifice returns in order to invest sustainably?'
                        xstrong
                      >
                        Do I have to sacrifice returns in order to invest sustainably?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-'}
                        title='Why should retirement plans add a sustainable investment option?'
                        xstrong
                      >
                        Why should retirement plans add a sustainable investment option?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.faqs}
                        title='FAQs'
                        xstrong
                      >
                      View all<LinkIcon/>
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </section>
            <br/>
            <br/>
          </ContainerDivs>
        </div>
      </div>
    )
  }
}
